var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconEuro18 = function SvgAIconEuro18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.09664C12.2625 4.41045 11.3264 4 10.3077 4C7.92862 4 6 6.23858 6 9C6 11.7614 7.92862 14 10.3077 14C11.3264 14 12.2625 13.5896 13 12.9034",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.75H10.5",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.25H10.5",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
};
export { SvgAIconEuro18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xMyA1LjA5NjY0QzEyLjI2MjUgNC40MTA0NSAxMS4zMjY0IDQgMTAuMzA3NyA0QzcuOTI4NjIgNCA2IDYuMjM4NTggNiA5QzYgMTEuNzYxNCA3LjkyODYyIDE0IDEwLjMwNzcgMTRDMTEuMzI2NCAxNCAxMi4yNjI1IDEzLjU4OTYgMTMgMTIuOTAzNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KPHBhdGggZD0iTTUgNy43NUgxMC41IiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiAvPgo8cGF0aCBkPSJNNSAxMC4yNUgxMC41IiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiAvPgo8L3N2Zz4=";